export enum PaymentMethodType {
  ApplePay = 'applepay',
  Card = 'card',
  MobilePay = 'mobilepay',
  VippsRecurring = 'vipps_recurring',
  Betalingsservice = 'betalingsservice',
  Unknown = '',
}
